import React from "react";
import { TFees } from "properties/_models/PropertyMdl";
import { useTranslation } from "react-i18next";
import UnitOrPropertyHeaderText from "units/UnitHeader/UnitOrPropertyHeaderText";
import { formatPesosPrice, formatPrice } from "_common/_utils/currencyUtils";
import { PropertyCardPrice } from "properties/propertyCard/components/PropertyCardPrice";
import PropertyOrUnitHeaderText from "properties/propertyPage/PropertyHeaderText";
import { TPhasesMdl } from "admin/phases/_models/PhasesMdl";
import { getLabelOfPhase } from "_common/_utils/getLabelOfPhase";

export interface TUnitHeaderPrice {
    _id: string;
    name: string;
    price: number;
    priceInPesos: number;
    isInPesosUnit: boolean;
    priceIsNotDisplayed: boolean;
    fees?: TFees;
    variant?: string;
    phase?: TPhasesMdl;
    feesType?: string;
    feesValue?: string;
}

type Props = {
    item: TUnitHeaderPrice;
};

export function UnitHeaderPrices({ item }: Props) {
    const { t } = useTranslation();
    const name = item.variant ? item.name + " - " + item.variant : item.name;

    return (
        <div className={"flex flex-col gap-2 flex-1"}>
            <h2 className="text-2xl font-medium text-[#1A3A45] mb-4">{t("unitPage.header.title", { name: name })}</h2>
            <div className={"font-semibold text-[#1A3A45] text-xl"}>
                {item.priceIsNotDisplayed ? (
                    <>{t("propertiesPage.card.priceOnRequest")}</>
                ) : (
                    <>
                        {item.isInPesosUnit ? (
                            <>{formatPesosPrice(item.priceInPesos)}</>
                        ) : (
                            <>{formatPrice(item.price, false, false)}</>
                        )}
                    </>
                )}
            </div>
            <PropertyCardPrice
                isInPesosProperty={item.isInPesosUnit}
                priceInPesosMin={item.priceInPesos}
                priceMin={item.price}
                isPriceNotDisplayed={item.priceIsNotDisplayed}
                isNotFrom
            />
            {item?.phase && (
                <div className={"mt-5"}>
                    <PropertyOrUnitHeaderText
                        title={t("property.deliveryDate")}
                        description={getLabelOfPhase(item.phase)}
                    />
                </div>
            )}
            <div className="mt-5">
                {!!item.feesType && !!item.feesValue && (
                    <UnitOrPropertyHeaderText
                        title={t("propertyPage.fees")}
                        description={t(`propertyPage.feesTypes.${item.feesType}`, {
                            count: Number(item.feesValue),
                        })}
                    />
                )}
            </div>
        </div>
    );
}
